import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ImmomioIconName } from '../../models';

@Directive()
export class IconButtonBaseComponent {
  @Input() icon: ImmomioIconName;
  @Input() className?: string;
  @Input() size?: number;
  @Output() tapped: EventEmitter<boolean> = new EventEmitter();
}
